import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const RemoveTrailingSlash = ({ ...rest }) => {
  const location = useLocation();

  // If the last character of the url is '/'
  if (location.pathname.match('/.*/$')) {
    return (
      <Navigate
        replace
        {...rest}
        to={{
          pathname: (() => {
            let pathname = location.pathname;
            while (pathname.endsWith('/')) {
              pathname = pathname.slice(0, -1);
            }
            return pathname;
          })(),
          search: location.search,
          hash: location.hash,
        }}
      />
    );
  } else return null;
};
